module.exports = __webpack_public_path__ + "img/PMerchantTransport64_ua.82cbc90d.webp";